import request from '../../../api/request';

import {
  GroupedDocumentationItem,
  RequestedDocument,
} from '../../../types/signDocumentationTypes';
import {
  ApproveCoursePayload,
  AuthorizeRequestPayload,
  HomologationFormDataResponse,
  HomologationListFilter,
  HomologationListResponse,
  HomologationRequestDetail,
  RejectCoursePayload,
} from './types';

export type RequestDocumentsResponse = {
  requestedDocuments: RequestedDocument[];
  groupedDocuments?: GroupedDocumentationItem[];
};

const HOMOLOGATION = {
  FORM: '/maintainers-portal/homologation/form',
  REQUESTS: '/maintainers-portal/homologation/requests',
};

export function getHomologationFormData() {
  return request<HomologationFormDataResponse>(HOMOLOGATION.FORM);
}

export function getHomologationRequests(params: HomologationListFilter) {
  return request<HomologationListResponse>(HOMOLOGATION.REQUESTS, {
    params,
  });
}

export function getHomologationRequestDetail(requestId: number) {
  return request<HomologationRequestDetail>(
    `${HOMOLOGATION.REQUESTS}/${requestId}`,
  );
}

export function approveCourse(
  requestId: number,
  courseId: number,
  data: ApproveCoursePayload,
) {
  return request(
    `${HOMOLOGATION.REQUESTS}/${requestId}/courses/${courseId}/approve`,
    { method: 'POST', data },
  );
}

export function rejectCourse(
  requestId: number,
  courseId: number,
  data: RejectCoursePayload,
) {
  return request(
    `${HOMOLOGATION.REQUESTS}/${requestId}/courses/${courseId}/reject`,
    { method: 'POST', data },
  );
}

export function sendToSignature(requestId: number) {
  return request<{ success: boolean }>(
    `${HOMOLOGATION.REQUESTS}/${requestId}/send-to-signature`,
    { method: 'POST' },
  );
}

export function uploadCourseFile(
  requestId: number,
  courseId: number,
  file: File,
) {
  const formData = new FormData();
  formData.append('file', file);
  return request<{ fileId: number; fileName: string; fileExtension: string }>(
    `${HOMOLOGATION.REQUESTS}/${requestId}/courses/${courseId}/file`,
    {
      method: 'POST',
      data: formData,
    },
  );
}

export function downloadCourseFile(requestId: number, courseId: number) {
  return request<{ id: number; name: string; url: string }>(
    `${HOMOLOGATION.REQUESTS}/${requestId}/courses/${courseId}/file`,
  );
}

export function deleteCourseFile(requestId: number, courseId: number) {
  return request<{ success: boolean }>(
    `${HOMOLOGATION.REQUESTS}/${requestId}/courses/${courseId}/file`,
    { method: 'DELETE' },
  );
}

export function authorizeRequest(
  requestId: number,
  data: AuthorizeRequestPayload,
) {
  return request<{ success: boolean }>(
    `${HOMOLOGATION.REQUESTS}/${requestId}/authorize`,
    { method: 'POST', data },
  );
}

export function getRequestDocuments(postulationDetailId: number, step: string) {
  return request<RequestDocumentsResponse>(
    `/maintainers-portal/tuition-processes/postulation-details/${postulationDetailId}/step/${step}/documents`,
  );
}

export async function downloadActaPdf(requestId: number) {
  return request<Blob>(`${HOMOLOGATION.REQUESTS}/${requestId}/acta-pdf`, {
    responseType: 'blob',
  });
}

export async function downloadCertificadoActaPdf(requestId: number) {
  return request<Blob>(
    `${HOMOLOGATION.REQUESTS}/${requestId}/certificado-acta-pdf`,
    { responseType: 'blob' },
  );
}
